import { render, staticRenderFns } from "./ed-editable-label.vue?vue&type=template&id=8a74fd4e&scoped=true&"
import script from "./ed-editable-label.ts?vue&type=script&lang=ts&"
export * from "./ed-editable-label.ts?vue&type=script&lang=ts&"
import style0 from "./ed-editable-label.scss?vue&type=style&index=0&id=8a74fd4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a74fd4e",
  null
  
)

export default component.exports